import React, { useState, type ReactElement, type ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface RailTooltipProps {
  label: ReactNode;
  /** Only the icon rail needs names next to its icons; expanded, the texts are there. */
  enabled: boolean;
  children: ReactElement;
}

/**
 * Tooltip beside a sidebar entry, on hover and on keyboard focus. Needs a
 * TooltipProvider above it (the Sidebar has one).
 */
export default function RailTooltip({ label, enabled, children }: RailTooltipProps) {
  const [open, setOpen] = useState(false);
  // Controlled on purpose: Radix would remember a hover from the expanded
  // state and pop the tooltip up the moment the rail collapses.
  if (!enabled && open) setOpen(false);

  return (
    <Tooltip open={enabled && open} onOpenChange={(next) => setOpen(enabled && next)}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="right" sideOffset={12} className="motion-reduce:animate-none">
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
